/**
 * FirmaPersonelDetailPage.jsx — Personel Detayı
 * Route: /Firma/Personel/:personelId
 *
 * Personel Listesi'nin (FirmaPersonelListPage.jsx) "Detaylar" satır aksiyonunun
 * hedefi — tek bir personelin KVKK onayı ve bireysel SGK/İSG/Sağlık/Mesleki
 * Eğitim belge durumlarını gösterir. Firma çapındaki 3 belgenin (Firma İSG
 * Taahhütnamesi/İş Yeri Hekimi Ataması/İş Güvenliği Uzmanı Ataması) yükleme
 * yeri FirmaKartPage.jsx'in Evraklar sekmesine taşındı — personel başına değil
 * firma başına tek kayıt oldukları için burada tekrar tekrar göstermek/yüklemek
 * yerine tek bir yerden yönetiliyorlar. Bu 3 belge üçü de onaylıysa bireysel 4
 * belge yine de "Muaf" olarak işaretlenir (bkz. firmaProfileService.js'teki
 * firmaBelgeleriAggregateStatus/computeCardEligible — o hesap firmaBelgeleri
 * verisini hâlâ kullanır, sadece bu sayfadaki gösterim/yükleme kaldırıldı).
 * Belge yükleme mock olarak burada var (bkz. uploadPersonelBelgesi — aynı desen
 * FirmaAnasayfaListPage.jsx'teki Fuar Evrakları yükleme akışı), onay/red admin
 * tarafına ait — yüklenen belge "Beklemede" durumuna döner. Onaylı (yeşil) veya
 * muaf belgeler için yükleme butonu gösterilmez.
 *
 * 2026-07-23 revizyonu: Personel Listesi'ndeki ikon-kare belge kutucukları artık
 * tıklanabilir ve buraya `?belge=<docKey>` query param'ıyla yönlendiriyor —
 * sayfa açılışında ilgili BelgeCard'a scrollIntoView + 2.5sn'lik kenarlık
 * vurgusu uygulanır (bkz. focusBelgeKey, doğrudan DOM üzerinde çalışan effect).
 *
 * 2026-07-24 revizyonu: Sayfa "Belgeler" (KVKK + 4 belge, varsayılan sekme —
 * ?belge= odağı bu yüzden burada çalışır) ve "Detay Bilgileri" (TC no/uyruk/
 * telefon/rol) olmak üzere iki sekmeye bölündü — desen FirmaKartPage.jsx'teki
 * Nav pills ile aynı. Kart Alabilir/Alamaz rozeti bilinçli olarak sekmelerin
 * dışında, üstteki kimlik bloğunda kaldı (Personel Listesi'ndeki köşe-ribbon'la
 * aynı gerekçe — bkz. PersonelKartRibbon). Belgeler sekmesinde KVKK, diğer 4
 * belgeden bir VDivider ile görsel olarak ayrılıyor.
 *
 * 2026-08-29 revizyonu: firma çapındaki 3 belge (yukarıda anlatılan İSG
 * Taahhütnamesi/İş Yeri Hekimi/İş Güvenliği Uzmanı) bu sayfaya SALT OKUNUR olarak
 * geri geldi — "Belgeler" sekmesinin EN SAĞINDA ayrı bir kart. Yükleme yeri hâlâ
 * FirmaKartPage.jsx'in Evraklar sekmesi (Personel Listesi'ndeki "Firma İSG Belgeleri"
 * kutucuğu da oraya gidiyor, bkz. PersonelDocTiles.goTo); buradaki kart yalnızca
 * durumu gösterir, çünkü kişisel 4 belgenin "Muaf" olmasının sebebi budur ve
 * dekoratör bunu görmeden neden muaf olduğunu (ya da olmadığını) anlayamıyordu.
 *
 * 2026-08-11 revizyonu (mock→backend reconciliation, bkz.
 * docs/guides/FE-PersonnelController-guide.md): FirmaPersonelListPage.jsx'teki
 * aynı selectedFuarId/LIVE_TEST_FUAR_IDS köprüsü — standId'li Firma detay
 * sayfalarının (FirmaStandDetailPage.jsx vb.) aksine personId hem mock hem
 * canlıda sayısal olduğundan `isNumericId` ile ayırt edilemiyor, bu yüzden
 * fuar sinyaline ihtiyaç var. Belge yükleme artık gerçek uçlara gidiyor (bkz.
 * firmaProfileService.js'teki uploadPersonelBelgesi'nin 2026-08-11 notu) — KVKK
 * için `person_display_name` gerekiyor, `person.name` ile besleniyor.
 *
 * Backlog #142/#145/#250 (2026-10-02, yalnızca canlı görünüm — mock'ta eski davranış): SGK/İSG
 * kutularında Yükle bir VARYANT seçimi açar (BelgeVaryantModal: tek kişilik İşe Giriş Bildirgesi /
 * Sertifika ya da firmanın paylaşımlı Hizmet Dökümü / Eğitim Katılım Listesi'ne bu çalışanı ekle),
 * kutu dolduran belgenin türünü ve "Firma belgesi" rozetini yazar; paylaşımlı belgenin dosyası yalnızca
 * sahibi firmaya açılır. Her kutuda Taşı / Havuza al (BelgeTasimaModal, bedeli önceden söyler) ve
 * taşındı notu; sekmenin altında Havuz kartı (KisiHavuzKarti).
 *
 * Backlog #252 (2026-10-02): KVKK kartında YÜKLEME YOK. KVKK kişinin kendi rızasıdır; backend #249'dan beri
 * firma hesabı `POST /personnel/kartduzenle/{id}/kvkk` ve `/dosyaekle` file_type 56 için 403 alır (yukarıdaki
 * 2026-08-11 notundaki "KVKK için person_display_name" akışı artık yalnızca denetmen tarafında —
 * personelBelgeService.uploadKvkkBelgesi). Kare, `kvkkDijitalOnay.tamam` ise belge olmasa da yeşil okunur.
 *
 * Backlog #511 (2026-10-19): etkin arayüz seti YABANCI KATILIMCI iken Belgeler sekmesi sadeleşir — Kişisel Belgeler yalnızca GDPR (salt durum) ve
 * Pasaport (KimlikPasaportModal: numara, ülke, dosya), Meslekler / etiketsiz sertifika / belge havuzu hiç gösterilmez, sağdaki firma kartı
 * yalnızca İmza Sirküsü + İSG Taahhütnamesi'ni söyler. Yerli Katılımcı ve Yabancı Dekoratör eski sayfayı görür.
 *
 * Backlog #247 (2026-10-02): firmanın kişiyle ilişkisi bittiyse (`iliskiSonlandirildi`, backend #112) kişi
 * SALT OKUNUR: Yükle / Taşı / Havuza al ve Havuz kartının yükle-ata-sil düğmeleri gösterilmez (yazma uçları
 * 403 verirdi, mesajı ancak tıklayınca görünürdü), başlıkta "İlişki Sonlandırıldı" rozeti çıkar.
 */
import React, { useContext, useEffect, useState } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import {
  Container, Card, CardBody, CardHeader, Row, Col, Nav, NavItem, NavLink, Badge, Spinner, Alert, Button,
} from "reactstrap";
import {
  ArrowLeft, User, Phone, Globe, ShieldCheck, Landmark, HardHat, HeartPulse,
  GraduationCap, Upload, Ban, Building2, Stethoscope, FileCheck2, Briefcase,
} from "lucide-react";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import KisiDosyaLink from "../../Components/Kisi/KisiDosyaLink";
import { EslesmeKarti } from "../../Components/Kisi/PersonelDurumParcalari";
import { IliskiBitisRozeti } from "../../Components/Kisi/PersonelKartParcalari";
import DocumentPreviewModal from "../../Components/Common/DocumentPreviewModal";
import MainContext from "../../Components/Contexts/MainContext";
// #403: the live branch takes the logged-in company's id from the portal context (GET /portal/context).
import { usePortal } from "../../Components/Contexts/PortalContext";
// WAS (until #403): import { getFirmaPersonelDetay, TEST_DECORATOR_FIRMA_ID } from "../../services/firmaPersonelListService";
import { getFirmaPersonelDetay } from "../../services/firmaPersonelListService";
import { FILE_APPROVAL_STATUS } from "../../services/projectService";
import { MOCK_DECORATOR_FIRMA_ID, uploadPersonelBelgesi } from "../../services/firmaProfileService";
import { kartDurumuMeta, isverenYolu, isverenEtiketi } from "../../services/kartDurumuService"; // WAS (until #334): ..., ISVEREN_ETIKETI }
// Backlog #142/#145/#250 — SGK/İSG varyant seçimi, belge taşıma, kişi havuzu (yalnızca canlı görünümde).
import BelgeVaryantModal from "../../Components/Kisi/BelgeVaryantModal";
import BelgeTasimaModal, { tasimaMesaji } from "../../Components/Kisi/BelgeTasimaModal";
import KisiHavuzKarti from "../../Components/Kisi/KisiHavuzKarti";
import { useTasimaNotlari, tasimaNotu } from "../../Components/Kisi/belgeTasimaNotu";
import { BELGE_SABLON_TIPI, belgeVaryantAdi, dosyaAcilabilir, paylasimliMi, tasiBelge } from "../../services/personelBelgeService";
import BelgeSablonuBaglantilari from "../../Components/Common/BelgeSablonuBaglantilari";
import useSablonHaritasi from "../../Components/Common/useSablonHaritasi";
import { EtiketsizSertifikaKarti } from "../../Components/Kisi/MeslekiEgitimKartlari";
import { kisiMeslekleri, meslekiYuvalar, etiketsizSertifikalar } from "../../Components/Kisi/meslekler";
import KisiMeslekleriKarti from "../../Components/Kisi/KisiMeslekleriKarti";
import { MeslekBilgisi } from "../../Components/Kisi/KartUygunsuzluklari";
import { MODUL, SEVIYE } from "../../services/portalService";
import { isgGrubu, grupBelgeKareleri, yabanciKatilimciFirmaKareleri } from "../../Components/Firma/belgeGruplari";
import KimlikPasaportModal from "../../Components/Kisi/KimlikPasaportModal";
import { GdprKarti, PasaportKarti, yabanciKatilimciMi } from "../../Components/Kisi/YabanciKatilimciParcalari";
import { sadePanelMi } from "../../services/sadePanel";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";

function getCurrentFirmaId() {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    return user?.firmaId ?? MOCK_DECORATOR_FIRMA_ID;
  } catch {
    return MOCK_DECORATOR_FIRMA_ID;
  }
}

// FirmaPersonelListPage.jsx'teki aynı isimli sabitlerin dosya-yerel kopyası.
// WAS (until #398): only the two seeded test fairs ran on the real backend, every other fair fell back to mock data:
// const LIVE_TEST_FUAR_IDS = [298, 299];
// const isLiveTestFuarId = (fuarId) => LIVE_TEST_FUAR_IDS.includes(Number(fuarId));
// #398: a full-simulation test creates a NEW fair, so every real fair id is live.
const isLiveTestFuarId = (fuarId) => Number(fuarId) > 0;

const PERSONEL_BELGE_META = [
  { key: "sgk", label: "SGK", icon: Landmark },
  { key: "isg", get label() { return i18n.t("portal:personelDetay.isg"); }, icon: HardHat },
  { key: "saglik", get label() { return i18n.t("portal:personelDetay.saglik"); }, icon: HeartPulse },
  { key: "meslekiEgitim", get label() { return i18n.t("portal:personelDetay.meslekiEgitim"); }, icon: GraduationCap },
];

// Yalnızca MOCK satırların yedeği (satırda `firmaBelgeGruplari` yok): eski üç sabit anahtar. Bu sayfada
// SALT OKUNUR (bkz. dosya başı 2026-08-29 notu). Canlıda kutucuklar firmaIsgKareleri'yle ISG grubundan çizilir.
const FIRMA_BELGE_META = [
  { key: "firmaIsgTaahhutnamesi", get label() { return i18n.t("portal:personelDetay.firmaIsgTaahhutnamesi"); }, icon: FileCheck2 },
  { key: "isYeriHekimiAtamasi", get label() { return i18n.t("portal:personelDetay.isYeriHekimiAtamasi"); }, icon: Stethoscope },
  { key: "isGuvenligiUzmaniAtamasi", get label() { return i18n.t("portal:personelDetay.isGuvenligiUzmaniAtamasi"); }, icon: ShieldCheck },
];

// #258 — "Firma İSG Belgeleri" kutucukları: satırın ISG grubundaki belgeler olduğu gibi (İşveren İSG
// Görevlendirmesi'ni yalnızca grup taşıyorsa içerir; #483: bugün her Yerli firmada taşır, onaylı 99 varken
// onaysız 88/89 gri "Uygulanamaz" okunur). Grup yoksa (mock) eski üçlü.
function firmaIsgKareleri(person) {
  const grup = isgGrubu(person.firmaBelgeGruplari);
  if (grup) {
    return grupBelgeKareleri(grup).map((k) => (
      { key: `grup-${k.fileTypeId}`, label: k.ad, icon: FileCheck2, status: k.status, aciklama: k.note, uygulanamaz: k.uygulanamaz }
    ));
  }
  return FIRMA_BELGE_META.map((b) => (
    { ...b, status: person.firmaBelgeleri?.[b.key]?.status ?? null, aciklama: null }
  ));
}

// bkz. aynı sabitler FirmaPersonelListPage.jsx'te (ROLE_LABELS/ROLE_COLORS) —
// bu sayfanın Detay sekmesinde rol rozetini aynı dilde göstermek için tekrar
// tanımlanıyor.
const ROLE_LABELS = { get isveren() { return i18n.t("portal:personelDetay.isveren"); }, get isci() { return i18n.t("portal:personelDetay.isci"); } };
const ROLE_COLORS = { isveren: "primary", isci: "secondary" };

const TABS = [
  { key: "belgeler", get label() { return i18n.t("portal:personelDetay.belgeler"); } },
  { key: "detay", get label() { return i18n.t("portal:personelDetay.detayBilgileri"); } },
];

// Renkler sabit hex — bu temanın çalışma zamanı --bs-*/--vz-* CSS değişkenleri
// yok (bkz. aynı çözüm FirmaPersonelListPage.jsx'teki StatusTile'da).
const NEUTRAL_GRAY = "#878a99";
const STATUS_HEX = { warning: "#f7b84b", success: "#0ab39c", danger: "#f06548" };
const MUAF_HEX = "#299cdb";

// KURAL: Col ile sarmalama artık burada değil, çağıran yerde yapılıyor — KVKK
// ile diğer 4 belge, Kişisel Belgeler sekmesinde iki ayrı grup olarak farklı
// genişliklerde diziliyor (bkz. FirmaPersonelDetailPage render'ındaki kullanım).
// `previewable=false`: firma belgeleri bu sayfada yalnızca DURUM gösterir — dosyanın
// kendisi burada yönetilmediği (ve elimizde bir URL de olmadığı) için sahte bir
// Lorem Ipsum önizlemesi açmak yanıltıcı olurdu.
//
// Backlog #142/#145/#250 (yalnızca canlı görünümde doldurulur): `varyantAdi` kutuyu dolduran
// belgenin türü (İşe Giriş Bildirgesi / Hizmet Dökümü …); `paylasimli` firma belgesi rozeti;
// `acilabilir=false` paylaşımlı belgenin dosyası bu firmaya kapalı (yalnızca sahibi firma açar);
// `onVaryantAc` SGK/İSG'de Yükle'nin yerini alır; `onTasi`/`onHavuza` belge taşıma; `tasimaNotu`
// "taşındı" notu.
//
// Backlog #252: `dijitalOnay` KVKK'nın üçüncü kaynağı — kişinin kendi dijital onayı (backend #139,
// `kvkkDijitalOnay.tamam`). Belge olmasa da kare YEŞİL okunur; `aciklama` kutunun altına küçük not yazar
// (KVKK için yükleme düğmesi firmada yok, nedeni burada söylenir).
function BelgeCard({
  Icon, label, status, muaf = false, docKey, uploading = false, onUpload, previewable = true,
  personId = null, fileId = null,
  varyantAdi = null, paylasimli = false, acilabilir = true, onVaryantAc, onTasi, onHavuza, tasimaNotu: not = null,
  dijitalOnay = false, aciklama = null, sayilmiyor = false, uygulanamaz = false, sablon = null,
  sade = false,
}) {
  const { t } = useTranslation("portal");
  const info = status != null ? FILE_APPROVAL_STATUS[status] : null;
  const dijitalYesil = dijitalOnay && status !== 1;
  // #372: onaylı görünen ama o meslek için SAYILMAYAN sertifika (süresi dolmuş, fuar için eski) yeşil "tamam" gibi okunmasın.
  // #442: UYGULANAMAZ firma belgesi nötr gri, "Kayıt yok" okunmaz (sayilmiyor'un tersine uyarı rengi değil).
  const background = uygulanamaz ? NEUTRAL_GRAY : muaf ? MUAF_HEX : dijitalYesil ? STATUS_HEX.success : sayilmiyor ? STATUS_HEX.warning : info ? STATUS_HEX[info.color] ?? NEUTRAL_GRAY : NEUTRAL_GRAY;
  // ⚠️ 2026-08-28'den beri firma belgeleri kimseyi MUAF TUTMUYOR — tam tersi, kadronun
  // ŞARTI oldular. Alan adı (`muaf`) eski, anlamı yeni: "firma üçlüsü tamam". Rozeti
  // "Muaf" diye etiketlemek aktif olarak yanlış bilgi verirdi (rehberin açık uyarısı).
  const badgeLabel = uygulanamaz ? i18n.t("components:belgeGruplari.uygulanamaz") : muaf ? t("personelDetay.firmaBelgeleriTamam") : dijitalYesil ? t("personelDetay.dijitalOnay") : sayilmiyor ? t("personelDetay.sayilmiyor") : info ? info.label : t("personelDetay.kayitYok");
  // Gerçek dosya elimizdeyse (canlı veri) sahte önizleme yerine kimlik doğrulamalı
  // indirme sunuyoruz; mock'ta `fileId` yok, eski davranış korunuyor.
  const gercekDosya = personId != null && fileId != null;
  const canUpload = (!!onUpload || !!onVaryantAc) && !muaf && status !== 1;
  const inputId = `belge-upload-${docKey}`;
  // Mock veride dosya adı/içerik yok (bkz. dosya başı 2026-07-23 notu — sadece
  // status), bu yüzden gerçekten yüklenmiş bir belge varsa (muaf/kayıt-yok değil)
  // ikon+rozete tıklamak Lorem Ipsum'lu bir sayfa önizlemesi açar.
  const [previewOpen, setPreviewOpen] = useState(false);
  const hasFile = previewable && !gercekDosya && status != null && !muaf;
  return (
    <Card id={`belge-card-${docKey}`} className="h-100">
      <CardBody className="text-center">
        <div
          className="d-inline-flex align-items-center justify-content-center rounded-3 mb-2"
          role={hasFile ? "button" : undefined}
          title={hasFile ? t("personelDetay.belgeyiOnizlemekIcinTiklayin") : undefined}
          style={{ width: 44, height: 44, background, cursor: hasFile ? "pointer" : undefined }}
          onClick={hasFile ? () => setPreviewOpen(true) : undefined}
        >
          <Icon size={20} color="#fff" />
        </div>
        <div className="small mb-2">{label}</div>
        {varyantAdi && (
          <div className="small text-muted mb-2 d-flex align-items-center justify-content-center gap-1 flex-wrap">
            {varyantAdi}
            {paylasimli && <Badge color="info" className="fw-normal">{t("personelDetay.firmaBelgesi")}</Badge>}
          </div>
        )}
        {/* #511: reactstrap <Badge> bu temada `bg-secondary !important` ile satır içi rengi eziyordu, rozet her durumda yeşil-mavi çıkıyordu
            (kare gri, rozet yeşil-mavi); düz span.badge satır içi rengi alır. WAS: <Badge style={{ background, ... }}>. */}
        <span
          className="badge text-white"
          style={{ backgroundColor: background, cursor: hasFile ? "pointer" : undefined }}
          onClick={hasFile ? () => setPreviewOpen(true) : undefined}
        >
          {badgeLabel}
        </span>
        {gercekDosya && (
          <div className="mt-2">
            {acilabilir ? (
              <KisiDosyaLink personId={personId} fileId={fileId} label={t("personelDetay.ac")} />
            ) : (
              <span className="small text-muted">{t("personelDetay.dosyayiYalnizcaBelgeyiYukleyenFirma")}</span>
            )}
          </div>
        )}
        {not && <div className="small text-muted fst-italic mt-2">{not}</div>}
        {aciklama && <div className="small text-muted mt-2">{aciklama}</div>}
        {/* #503: kurumun bu belge için verdiği boş form / örnek */}
        <BelgeSablonuBaglantilari sablon={sablon} />
        {/* #704: in the simple panel the card's one button is the primary action (as on the Yabancı Katılımcı's Passport card);
            Move / Move to pool step back to quiet links under it. WAS: always two `color="light"` buttons here. */}
        {gercekDosya && !paylasimli && (onTasi || onHavuza) && (
          <div className="mt-2 d-flex justify-content-center gap-1 flex-wrap">
            {onTasi && <Button color={sade ? "link" : "light"} size="sm" className={sade ? "p-0 text-muted" : undefined} onClick={onTasi}>{t("personelDetay.tasi")}</Button>}
            {onHavuza && <Button color={sade ? "link" : "light"} size="sm" className={sade ? "p-0 text-muted" : undefined} onClick={onHavuza}>{t("personelDetay.havuzaAl")}</Button>}
          </div>
        )}
        <DocumentPreviewModal
          isOpen={previewOpen}
          toggle={() => setPreviewOpen(false)}
          fileName={t("personelDetay.belgesi", { label })}
        />
        {canUpload && (
          <>
            {!onVaryantAc && (
              <input
                id={inputId}
                type="file"
                className="d-none"
                onChange={(e) => {
                  const file = e.target.files?.[0];
                  if (file) onUpload(file);
                  e.target.value = "";
                }}
              />
            )}
            <div className="mt-2">
              <Button
                color="primary" outline size="sm" disabled={uploading}
                onClick={onVaryantAc ?? (() => document.getElementById(inputId)?.click())}
              >
                {/* #704: the Passport card's button has no icon; the simple panel's cards match it. WAS: always the Upload icon. */}
                {uploading ? <Spinner size="sm" /> : <>{!sade && <Upload size={14} className="me-1" />}{t("common:yukle")}</>}
              </Button>
            </div>
          </>
        )}
      </CardBody>
    </Card>
  );
}

// bkz. aynı köşe/ayraç deseni FirmaPersonelListPage.jsx'teki VDivider — KVKK'yı
// diğer 4 belgeden görsel olarak ayırmak için kullanılıyor.
function VDivider() {
  return (
    <div
      className="d-none d-md-block"
      style={{ width: 1, alignSelf: "stretch", backgroundColor: "currentColor", opacity: 0.15 }}
    />
  );
}

export default function FirmaPersonelDetailPage() {
  const { t: tx } = useTranslation("portal");
  const { t: tc } = useTranslation("components");
  const { personelId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const focusBelgeKey = searchParams.get("belge");
  const { selectedFuarId } = useContext(MainContext);
  const portal = usePortal();
  // #511: etkin arayüz seti Yabancı Katılımcı → yalnızca GDPR + Pasaport (bkz. dosya başı notu).
  // #704: bilerek sadePanelMi DEĞİL: bu sayfada `yabanciKatilimci`nın değiştirdiği her şey kişinin ve firmanın BELGELERİ (GDPR + Pasaport,
  // 78 + 79, meslekler, havuz). Sade panel modunda Yerli bir firmanın kişisi kendi setini (KVKK, SGK, ... backend'in listesi) görmeye devam eder.
  const yabanciKatilimci = yabanciKatilimciMi(portal);
  // #704 (Deniz, 2026-11-03): the LAYOUT of the document cards is the simple panel's, though; a Yerli / foreign Dekoratör company in Sade
  // panel modu gets the Yabancı Katılımcı's look (one even grid, one primary button per card) with its own documents. The real Yabancı
  // Katılımcı draws GdprKarti + PasaportKarti above, so this is only for the other companies.
  const sadeKartlar = sadePanelMi(portal) && !yabanciKatilimci;
  const [pasaportAcik, setPasaportAcik] = useState(false);
  const isLiveTestFuar = isLiveTestFuarId(selectedFuarId);
  // #503: kurumun verdiği boş form / örnek (KVKK 56, İSG katılım listesi 98), arayüz dilinde; yalnızca canlı fuarlarda çekilir.
  const sablonlar = useSablonHaritasi(selectedFuarId, { etkin: isLiveTestFuar });
  // WAS (until #403): const firmaId = isLiveTestFuar ? TEST_DECORATOR_FIRMA_ID : getCurrentFirmaId();
  // null while /portal/context loads: the fetch effect below waits for it instead of asking for firma "null".
  const firmaId = isLiveTestFuar ? (portal?.firmaId ?? null) : getCurrentFirmaId();

  // Varsayılan sekme "belgeler" — Personel Listesi'nden ?belge=<docKey> ile
  // gelindiğinde odaklanılacak BelgeCard bu sekmede render edilir (bkz. aşağıdaki
  // focusBelgeKey effect'i).
  const [activeTab, setActiveTab] = useState("belgeler");
  const [person, setPerson] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [infoMsg, setInfoMsg] = useState(null);
  const [uploadingKey, setUploadingKey] = useState(null);
  const [reloadToken, setReloadToken] = useState(0);
  // #142/#145: SGK/İSG varyant penceresi (slot anahtarı) ve belge taşıma penceresi ({ mod, key }).
  const [varyantSlot, setVaryantSlot] = useState(null);
  const [tasima, setTasima] = useState(null);
  const tasimaNotlari = useTasimaNotlari(personelId, isLiveTestFuar, reloadToken);

  useEffect(() => { document.title = i18n.t("portal:personelDetay.personelDetayiFds"); }, []);

  // KURAL: fetch mantığı bilinçli olarak Effect içinde tanımlanır (üst seviye
  // useCallback olarak paylaşılmaz) — aksi halde react-hooks/set-state-in-effect
  // ihlali oluşur. Yükleme sonrası reloadToken artırılarak yeniden çekilir.
  useEffect(() => {
    if (!firmaId) return undefined; // #403: no request before the portal has delivered the company
    let ignore = false;

    async function run() {
      if (isLiveTestFuar && !selectedFuarId) {
        setLoading(false);
        return;
      }
      setLoading(true);
      setError(null);
      try {
        const detail = await getFirmaPersonelDetay(personelId, firmaId, {
          fuarId: selectedFuarId,
          forceLive: isLiveTestFuar,
        });
        if (!ignore) setPerson(detail);
      } catch (e) {
        if (!ignore) setError(e.message);
      } finally {
        if (!ignore) setLoading(false);
      }
    }

    run();
    return () => { ignore = true; };
  }, [personelId, firmaId, selectedFuarId, isLiveTestFuar, reloadToken]);

  // Personel Listesi'ndeki bir belge kutucuğundan ?belge=<docKey> ile gelindiyse
  // ilgili BelgeCard'a scroll edip kısa süreliğine kenarlıkla vurgular. React
  // state yerine doğrudan DOM üzerinde çalışır (react-hooks/set-state-in-effect
  // ihlaline girmemek için — bkz. dosya başı yorumu / new-page.md).
  useEffect(() => {
    if (loading || !person || !focusBelgeKey) return;
    const el = document.getElementById(`belge-card-${focusBelgeKey}`);
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "center" });
    el.classList.add("border-primary");
    el.style.borderWidth = "2px";
    const timer = setTimeout(() => {
      el.classList.remove("border-primary");
      el.style.borderWidth = "";
    }, 2500);
    return () => clearTimeout(timer);
  }, [loading, person, focusBelgeKey]);

  function showInfo(msg) {
    setInfoMsg(msg);
    setTimeout(() => setInfoMsg(null), 3500);
  }

  // #372: `meslekId` yalnızca Mesleki Eğitim'de — sertifika kişinin o fuardaki mesleklerinden birine etiketlenir.
  // `kartKey` birden çok meslek kartının yükleme göstergesini ayırır.
  async function handleUploadPersonelBelgesi(belgeKey, file, meslekId = null, kartKey = belgeKey) {
    setUploadingKey(`personel-${kartKey}`);
    setError(null);
    try {
      await uploadPersonelBelgesi(firmaId, personelId, belgeKey, file, {
        forceLive: isLiveTestFuar,
        fuarId: selectedFuarId,
        meslekId,
      });
      // Canlıda (backend #295, #297) firmanın yüklediği belge tarihsiz ve açık bir Beklemede kaydıyla yazılır: personel onaylayıp
      // geçerlilik tarihini girene kadar hiçbir şeye sayılmaz. (Eskiden review kaydı olmadan doğrudan "Onaylandı" okunurdu, bu yüzden
      // canlıda yalnızca "Belge yüklendi." deniyordu.)
      // WAS (until #297): showInfo(isLiveTestFuar ? tx("personelDetay.belgeYuklendi") : tx("personelDetay.belgeYuklendiOnayBekleniyor"));
      showInfo(isLiveTestFuar ? tx("personelDetay.belgeYuklendiFdsBekliyor") : tx("personelDetay.belgeYuklendiOnayBekleniyor"));
      setReloadToken((t) => t + 1);
    } catch (e) {
      setError(e.message);
    } finally {
      setUploadingKey(null);
    }
  }

  // #372: hiçbir mesleğe sayılmayan etiketsiz sertifikayı bir mesleğe atar (firma, kişinin o fuardaki herhangi bir mesleğini
  // seçebilir — başka firmanın verdiği dahil, adı gösterilmeden); etiket değişikliği belgeyi yeniden Beklemede'ye alır.
  async function sertifikaEtiketle(fileId, meslekId) {
    setError(null);
    try {
      await tasiBelge(person.id, fileId, { meslekId });
      showInfo(tx("personelDetay.sertifikaAtandi"));
      setReloadToken((t) => t + 1);
    } catch (e) {
      setError(e.message);
    }
  }

  if (loading) {
    return (
      <div className="page-content">
        <Container fluid className="text-center py-5"><Spinner color="primary" /></Container>
      </div>
    );
  }

  if (isLiveTestFuar && !selectedFuarId) {
    return (
      <div className="page-content">
        <Container fluid>
          <Alert color="info">{tx("personelDetay.buSayfayiGormekIcinOnce")}</Alert>
          <Button color="secondary" outline size="sm" onClick={() => navigate("/Firma/Personel")}>
            <ArrowLeft size={14} className="me-1" />{" "}{tx("personelDetay.listeyeDon")}
          </Button>
        </Container>
      </div>
    );
  }

  if (error && !person) {
    return (
      <div className="page-content">
        <Container fluid>
          <Alert color="danger">{error}</Alert>
          <Button color="secondary" outline size="sm" onClick={() => navigate("/Firma/Personel")}>
            <ArrowLeft size={14} className="me-1" />{" "}{tx("personelDetay.listeyeDon")}
          </Button>
        </Container>
      </div>
    );
  }

  if (!person) return null;

  // #247: ilişki bitmişse (person_to_firma aktif=0) backend yazma uçlarına 403 verir — yükleme/sil/taşıma
  // düğmeleri hiç gösterilmez, okuma (belge açma, durum) sürer.
  const salt = person.iliskiSonlandirildi === true;

  // Bir kişisel belgenin (SGK / İSG / Sağlık / bir mesleğin Mesleki Eğitim'i) kartı. #466: Mesleki Eğitim kartları artık "Meslekler"
  // kartında mesleğin satırında da çıkar, bu yüzden kart üretimi buradan paylaşılır.
  const kisiselBelgeKarti = ({ b, y, doc, kartKey, label }) => {
    // #142: SGK/İSG'de Yükle bir VARYANT seçimi açar (canlı görünümde).
    const varyantli = isLiveTestFuar && (b.key === "sgk" || b.key === "isg");
    return (
      <BelgeCard
        Icon={b.icon}
        label={label}
        status={doc.status}
        sayilmiyor={y != null && y.istenen && doc.status === 1 && y.sayilir === false}
        // 2026-10-02: canlıda `muaf` (= firma üçlüsü tamam) kişisel belgeyi MUAF TUTMAZ (2026-08-28
        // kararı, üstteki uyarı da bunu söylüyor) — ama kutu bunu yine de gerçek durumu gizleyip
        // Yükle'yi kaldırıyordu. Canlıda geçmiyoruz; mock görünüm eski davranışını koruyor.
        muaf={isLiveTestFuar ? false : person.muaf}
        docKey={kartKey}
        personId={person.id}
        fileId={doc.fileId ?? null}
        uploading={uploadingKey === `personel-${kartKey}`}
        onUpload={varyantli || salt ? undefined : (file) => handleUploadPersonelBelgesi(b.key, file, y?.meslekId ?? null, kartKey)}
        onVaryantAc={varyantli && !salt ? () => setVaryantSlot(b.key) : undefined}
        varyantAdi={isLiveTestFuar && doc.fileId != null ? belgeVaryantAdi(doc.fileTypeId) : null}
        paylasimli={paylasimliMi(doc)}
        acilabilir={dosyaAcilabilir(doc, firmaId)}
        tasimaNotu={tasimaNotu(tasimaNotlari.get(doc.fileId))}
        onTasi={isLiveTestFuar && !salt ? () => setTasima({ mod: "tasi", key: b.key, doc, meslekAdi: y?.meslekAdi }) : undefined}
        onHavuza={isLiveTestFuar && !salt ? () => setTasima({ mod: "havuza", key: b.key, doc, meslekAdi: y?.meslekAdi }) : undefined}
        sablon={sablonlar[BELGE_SABLON_TIPI[b.key]]}
        sade={sadeKartlar}
      />
    );
  };
  // KVKK + the personal documents as one list of cards (KVKK first), so the simple panel's grid and the old two-group layout draw the same cards.
  const kvkkKarti = (
    <BelgeCard
      Icon={ShieldCheck} label={tx("personelDetay.kvkkOnayi")} status={person.documents.kvkk.status}
      docKey="kvkk"
      personId={person.id} fileId={person.documents.kvkk.fileId ?? null}
      dijitalOnay={!!person.kvkkDijitalOnay?.tamam}
      aciklama={tx("personelDetay.kvkkYiKisiKendiGirisinden")}
      sablon={sablonlar[BELGE_SABLON_TIPI.kvkk]}
      sade={sadeKartlar}
    />
  );
  // #372: kişi bu fuarda birden çok meslek taşıyorsa Mesleki Eğitim her mesleğin kendi kartı olur (yükleme o mesleğe etiketlenir); yuva yoksa
  // (mock / fuarsız) tek eski kart. #466: canlıda Mesleki Eğitim sertifikaları "Meslekler" kartının satırlarında çıkar, buradan düşer.
  const kisiselGirdiler = PERSONEL_BELGE_META.filter((b) => !(isLiveTestFuar && b.key === "meslekiEgitim")).flatMap((b) => {
    const yuvalar = b.key === "meslekiEgitim" ? meslekiYuvalar(person) : null;
    if (yuvalar) {
      return yuvalar.map((y, i) => ({
        b, y, doc: y.belge ?? {}, kartKey: i === 0 ? b.key : `${b.key}-${y.meslekId}`,
        label: yuvalar.length > 1 ? `${b.label} — ${y.meslekAdi}` : b.label,
      }));
    }
    return [{ b, y: null, doc: person.documents[b.key], kartKey: b.key, label: b.label }];
  });
  const kisiselGirdiSarmali = (girdi) => {
    const istenmiyor = girdi.y != null && !girdi.y.istenen;
    return {
      opacity: istenmiyor ? 0.6 : 1,
      title: istenmiyor ? tx("personelDetay.buMeslekIcinIstenmiyor") : undefined,
    };
  };
  // #466: bir mesleğin satırındaki sertifika kartı (yuva `meslekiEgitimler[]`den); mesleğin yuvası yoksa (sertifika sorulmuyor) boş.
  const meslekSertifikaKarti = (m) => {
    const y = (meslekiYuvalar(person) ?? []).find((x) => Number(x.meslekId) === Number(m.meslekId));
    if (!y) return null;
    const b = PERSONEL_BELGE_META.find((x) => x.key === "meslekiEgitim");
    const istenmiyor = !y.istenen;
    return (
      <div style={{ maxWidth: 240, opacity: istenmiyor ? 0.6 : 1 }} title={istenmiyor ? tx("personelDetay.buMeslekIcinIstenmiyor") : undefined}>
        {kisiselBelgeKarti({ b, y, doc: y.belge ?? {}, kartKey: `meslekiEgitim-${m.meslekId}`, label: b.label })}
      </div>
    );
  };
  // Meslek ekleme / kaldırma: PERSONEL modülü WRITE ve ilişki sürüyor (backend `denyIfCannotWritePerson`); mock fuarlarda meslek yok.
  const meslekYazabilir = isLiveTestFuar && !salt && (!portal || portal.enAzModul(MODUL.PERSONEL, SEVIYE.WRITE));

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title={tx("personelDetay.personel", { name: person.name })} pageTitle={tx("personelDetay.firma")} />

        {error && <Alert color="danger">{error}</Alert>}
        {infoMsg && <Alert color="info">{infoMsg}</Alert>}

        <Button color="secondary" outline size="sm" className="mb-3" onClick={() => navigate("/Firma/Personel")}>
          <ArrowLeft size={14} className="me-1" />{" "}{tx("personelDetay.listeyeDon")}
        </Button>

        <Card className="mb-4 overflow-hidden">
          <div className="bg-light">
            <div className="p-4">
              <div className="d-flex align-items-center gap-3 flex-wrap">
                <div
                  className="bg-white rounded-3 d-flex align-items-center justify-content-center shadow-sm flex-shrink-0"
                  style={{ width: 64, height: 64 }}
                >
                  {person.photo ? (
                    <img src={person.photo} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 12 }} />
                  ) : (
                    <User size={32} className="text-danger" />
                  )}
                </div>
                <div>
                  <h4 className="text-dark mb-0">{person.name}</h4>
                  <div className="d-flex align-items-center gap-2 flex-wrap mt-1">
                    {/* 2026-09-15: üç durumlu rozet — bkz. kartDurumuService.js; #539: portalda Yetkili / Kısmen Yetkili / Yetkisiz */}
                    <Badge color={kartDurumuMeta(person, { portal: true }).color}>
                      {kartDurumuMeta(person, { portal: true }).label}
                    </Badge>
                    {/* #248: karar işveren yolundan (kişisel belge yok, firmanın Firma Belgeleri) */}
                    {isverenYolu(person) && (
                      <Badge color="info" className="d-inline-flex align-items-center gap-1"
                        title={tx("personelDetay.kartKarariIsverenYolundanKvkk")}>
                        <Briefcase size={11} />{isverenEtiketi()}
                      </Badge>
                    )}
                    {person.forbidden && (
                      <Badge color="danger" className="d-inline-flex align-items-center gap-1">
                        <Ban size={11} />{tx("personelDetay.girisiYasakli")}
                      </Badge>
                    )}
                    <IliskiBitisRozeti record={person} />
                  </div>
                </div>
              </div>
            </div>
            <Nav pills className="px-4 gap-2 border-0">
              {TABS.map((t) => (
                <NavItem key={t.key}>
                  <NavLink
                    active={activeTab === t.key}
                    className={activeTab === t.key ? "bg-danger text-white" : "bg-white text-dark"}
                    style={{ cursor: "pointer", borderRadius: "6px 6px 0 0" }}
                    onClick={() => setActiveTab(t.key)}
                  >
                    {t.label}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
          </div>
        </Card>

        {/* Saka eşlemesine cevabınız + geçmişi (backlog #114); cevap Fuar Kadrosu listesinden verilir. */}
        <EslesmeKarti record={person} />

        {activeTab === "belgeler" && (
          <Row className="g-3 mb-4">
            <Col xl={8}>
              <Card className="h-100 mb-0">
                <CardHeader className="bg-white border-bottom">
                  <h5 className="mb-0">
                    <ShieldCheck size={18} className="me-2 text-primary" />
                    {/* WAS (until #704): {yabanciKatilimci ? ... } — the simple panel's other companies get the same heading now. */}
                    {yabanciKatilimci || sadeKartlar ? tc("yabanciKatilimci.belgelerBaslik") : tx("personelDetay.kisiselBelgeler")}
                  </h5>
                </CardHeader>
                <CardBody>
                  {/* #511: Yabancı Katılımcı — yalnızca GDPR (firma yükleyemez, salt durum) ve Pasaport. */}
                  {yabanciKatilimci && (
                    <Row className="g-3">
                      <Col md={6}><GdprKarti person={person} /></Col>
                      <Col md={6}><PasaportKarti person={person} salt={salt} onDuzenle={() => setPasaportAcik(true)} /></Col>
                    </Row>
                  )}
                  {/* #284: "Firmanın İSG belgeleri tamam — bu bir MUAFİYET DEĞİLDİR" uyarısı kaldırıldı (Deniz). Gerekçe
                      kodda kalıyor: 2026-08-28'den beri firma belgeleri kişisel belgelerin yerine geçmez, onlara EK bir
                      şarttır; kutular bu yüzden `muaf`a göre gerçek durumu gizlemez (aşağıdaki not). */}
                  {/* #704: the simple panel's look for the other companies, the same even grid as the two cards above (KVKK first, no divider,
                      no fixed 200 px column); a card the company's role does not ask for stays faded, as before. */}
                  {!yabanciKatilimci && sadeKartlar && (
                    <Row className="g-3">
                      {/* #252: KVKK kişinin kendi rızası — firma yükleyemez (backend #249, 403). Yükleme düğmesi yok; kişi kendi girişinden
                          verir ya da ıslak imzalı aslı SAKA personeline teslim eder. */}
                      <Col sm={6} xl={4}>{kvkkKarti}</Col>
                      {kisiselGirdiler.map((girdi) => {
                        const { opacity, title } = kisiselGirdiSarmali(girdi);
                        return <Col key={girdi.kartKey} sm={6} xl={4} style={{ opacity }} title={title}>{kisiselBelgeKarti(girdi)}</Col>;
                      })}
                    </Row>
                  )}
                  {!yabanciKatilimci && !sadeKartlar && (
                  <div className="d-flex align-items-stretch gap-3 flex-wrap">
                    <div style={{ width: 200, flexShrink: 0 }}>
                      {/* #252: KVKK kişinin kendi rızası — firma yükleyemez (backend #249, 403). Yükleme
                          düğmesi yok; kişi kendi girişinden verir ya da ıslak imzalı aslı SAKA personeline teslim eder. */}
                      {kvkkKarti}
                    </div>
                    <VDivider />
                    <div className="d-flex flex-wrap gap-3 flex-grow-1">
                      {/* #466: canlıda Mesleki Eğitim sertifikaları buradan çıktı — her mesleğin satırında (aşağıdaki "Meslekler" kartı);
                          mock görünüm (298/299 dışı fuarlar) eski tek kartı korur. */}
                      {kisiselGirdiler.map((girdi) => {
                        const { opacity, title } = kisiselGirdiSarmali(girdi);
                        return (
                          <div key={girdi.kartKey} style={{ flex: "1 1 180px", maxWidth: 240, opacity }} title={title}>
                            {kisiselBelgeKarti(girdi)}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  )}
                </CardBody>
              </Card>
            </Col>

            {/* Firma çapındaki 3 belge — EN SAĞDA, salt okunur (bkz. dosya başı
                2026-08-29 notu). Yükleme butonu bilerek yok: `onUpload` geçilmediği
                için BelgeCard zaten göstermiyor. */}
            <Col xl={4}>
              <Card className="h-100 mb-0">
                <CardHeader className="bg-white border-bottom">
                  <h5 className="mb-0">
                    <Building2 size={18} className="me-2 text-primary" />
                    {yabanciKatilimci ? tc("yabanciKatilimci.firmaBelgeleri") : tx("personelDetay.firmaIsgBelgeleri")}
                  </h5>
                </CardHeader>
                <CardBody>
                  <div className="d-flex flex-wrap gap-3">
                    {/* #511: Yabancı Katılımcı'dan yalnızca İmza Sirküsü ve İSG Taahhütnamesi istenir (#440 / #507). */}
                    {(yabanciKatilimci
                      ? yabanciKatilimciFirmaKareleri(person.firmaBelgeGruplari).map((k) => (
                        { key: `grup-${k.fileTypeId}`, label: k.ad, icon: FileCheck2, status: k.status, aciklama: k.note, uygulanamaz: k.uygulanamaz }
                      ))
                      : firmaIsgKareleri(person)
                    ).map((b) => (
                      <div key={b.key} style={{ flex: "1 1 120px", maxWidth: 220 }}>
                        <BelgeCard
                          Icon={b.icon}
                          label={b.label}
                          status={b.status}
                          docKey={`firma-${b.key}`}
                          previewable={false}
                          aciklama={b.aciklama}
                          uygulanamaz={b.uygulanamaz}
                        />
                      </div>
                    ))}
                  </div>
                  <div className="text-muted small mt-3">
                    {tx("personelDetay.buBelgelerPersonelBasinaDegil")}
                    <Button
                      color="link" size="sm" className="p-0 align-baseline"
                      onClick={() => navigate("/Firma/FirmaKart?tab=evraklar")}
                    >
                      {tx("personelDetay.firmaKartiEvraklar")}
                    </Button>{" "}
                    {tx("personelDetay.sekmesindenYapilir")}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}

        {/* #466 — kişinin meslekleri (canlı fuarlar): kim ekledi, kart o meslekle basılabilir mi, mesleğin Mesleki Eğitim sertifikası
            aynı satırda; firma kendi çalışanına ekler, yalnızca kendi eklediğini ve onaylı sertifikası olmayanı kaldırır. */}
        {activeTab === "belgeler" && isLiveTestFuar && !yabanciKatilimci && (
          <div className="mb-4">
            <KisiMeslekleriKarti
              personId={person.id} taraf="firma" yazabilir={meslekYazabilir}
              meslekler={kisiMeslekleri(person)} kartSatiri={person} yuvalar={meslekiYuvalar(person)}
              calisanBelgeleri={person.belgeKurali?.belgeler || []}
              renderSlot={meslekSertifikaKarti}
              onChanged={(msg) => { showInfo(msg); setReloadToken((t) => t + 1); }}
              onError={(msg) => setError(msg)}
            >
              <MeslekBilgisi kisi={person} kodlar={person.uygunsuzluklar || []} />
            </KisiMeslekleriKarti>
          </div>
        )}

        {/* #372 — 2+ meslek sertifika isterken hangisi olduğu söylenmemiş sertifikalar: hiçbir mesleğe sayılmaz, buradan atanır. */}
        {activeTab === "belgeler" && !yabanciKatilimci && etiketsizSertifikalar(person).length > 0 && (
          <div className="mb-4">
            <EtiketsizSertifikaKarti
              belgeler={etiketsizSertifikalar(person)}
              secenekler={(meslekiYuvalar(person) ?? []).filter((y) => y.istenen)}
              onEtiketle={salt ? undefined : sertifikaEtiketle}
              dosyaAc={(b) => (dosyaAcilabilir(b, firmaId)
                ? <KisiDosyaLink personId={person.id} fileId={b.fileId} label={tx("personelDetay.ac")} />
                : <span className="small text-muted">{tx("personelDetay.dosyayiYalnizcaBelgeyiYukleyenFirma")}</span>)}
              etiket={{
                baslik: tx("personelDetay.etiketsizBaslik"),
                incele: tx("personelDetay.ac"),
                hangiMeslek: tx("personelDetay.hangiMeslekIcin"),
                ata: tx("personelDetay.ata"),
                sonKullanma: tx("personelDetay.sonKullanma"),
                sifirlanir: tx("personelDetay.etiketsizSifirlanir"),
              }}
            />
          </div>
        )}

        {/* #250 — türü henüz belli olmayan dosyalar. Yalnızca canlı görünümde. */}
        {activeTab === "belgeler" && isLiveTestFuar && !yabanciKatilimci && (
          <KisiHavuzKarti
            personId={person.id} kisiAd={person.name} firmaId={firmaId} salt={salt}
            reloadToken={reloadToken} onChanged={() => setReloadToken((t) => t + 1)}
          />
        )}

        {pasaportAcik && (
          <KimlikPasaportModal
            kisi={{ personId: person.id, name: person.name }}
            belge={person.documents?.kimlikFotografi}
            fuarId={selectedFuarId}
            onClose={() => setPasaportAcik(false)}
            onSaved={() => setReloadToken((t) => t + 1)}
          />
        )}

        {varyantSlot && (
          <BelgeVaryantModal
            slot={varyantSlot} personId={person.id} personAd={person.name} firmaId={firmaId}
            fuarId={selectedFuarId}
            onClose={() => setVaryantSlot(null)}
            onDone={(msg) => { setVaryantSlot(null); showInfo(msg); setReloadToken((t) => t + 1); }}
          />
        )}

        {tasima && (
          <BelgeTasimaModal
            mod={tasima.mod} personId={person.id} kisiAd={person.name} firmaId={firmaId}
            doc={tasima.doc ?? person.documents[tasima.key]}
            belgeAdi={`${PERSONEL_BELGE_META.find((m) => m.key === tasima.key)?.label ?? tasima.key}${tasima.meslekAdi ? ` — ${tasima.meslekAdi}` : ""}${
              belgeVaryantAdi((tasima.doc ?? person.documents[tasima.key]).fileTypeId) ? ` — ${belgeVaryantAdi((tasima.doc ?? person.documents[tasima.key]).fileTypeId)}` : ""}`}
            onClose={() => setTasima(null)}
            onDone={(sonuc) => {
              setTasima(null);
              showInfo(tasimaMesaji(sonuc, { havuza: tasima.mod === "havuza" }));
              setReloadToken((t) => t + 1);
            }}
          />
        )}

        {activeTab === "detay" && (
          <Card className="mb-4">
            <CardHeader className="bg-white border-bottom">
              <h5 className="mb-0"><User size={18} className="me-2 text-primary" />{tx("personelDetay.detayBilgileri")}</h5>
            </CardHeader>
            <CardBody>
              <Row className="g-3">
                <Col md={3} sm={6}>
                  <div className="text-muted small">{tx("personelDetay.tcKimlikNo")}</div>
                  <div className="fw-semibold">{person.tcNo || person.maskedTcNo}</div>
                </Col>
                <Col md={3} sm={6}>
                  <div className="text-muted small d-flex align-items-center gap-1"><Globe size={12} />{tx("personelDetay.uyruk")}</div>
                  <div className="fw-semibold">{person.uyruk || "—"}</div>
                </Col>
                <Col md={3} sm={6}>
                  <div className="text-muted small d-flex align-items-center gap-1"><Phone size={12} />{tx("personelDetay.iletisim")}</div>
                  <div className="fw-semibold">{person.phone || "—"}</div>
                </Col>
                <Col md={3} sm={6}>
                  <div className="text-muted small">{tx("personelDetay.rol")}</div>
                  <Badge color={ROLE_COLORS[person.role]}>{ROLE_LABELS[person.role] ?? "—"}</Badge>
                </Col>
              </Row>
            </CardBody>
          </Card>
        )}
      </Container>
    </div>
  );
}
